import { useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme/theme";
import { adaltraTheme } from "@adaltra/ui";
import { theme as authTheme } from "../theme/atlasAuthTheme";

/** Shared authentication theme; authenticated pages retain their Portal theme. */
export function ApplicationTheme({ children }) {
  const { pathname } = useLocation();
  const isAuth = ["/", "/verificacion-2fa", "/recuperar-contrasena", "/restablecer-contrasena"].includes(pathname);
  return <ThemeProvider theme={pathname === "/" ? adaltraTheme : isAuth ? authTheme : theme} defaultMode="light" modeStorageKey="atlas-adaltra-mode" colorSchemeStorageKey="atlas-adaltra-scheme" noSsr>
    <CssBaseline />
    {children}
  </ThemeProvider>;
}

